import React, { useEffect } from "react";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import Spinner from "../../components/layout/Spinner";
import {
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from "../../shared/enums/candidatestatuss_enum";
import SingleView from "../../components/common/SingleView";
import { useSingleCandidatestatus } from "../../shared/hooks/UseCandidatestatus";
const ViewCandidatestatus = ({ match }) => {
  const [data] = useSingleCandidatestatus(match.params.id);
  const { loading, candidatestatus } = data;
  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink="View"
        />
        {!loading ? (
          candidatestatus && (
            <SingleView
              data={candidatestatus}
              inputFields={inputFields}
              label={PAGE_SINGLE_TITLE}
              link={LINK_URL}
              id={candidatestatus._id}
            />
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewCandidatestatus;
                